<template>
  <div class="container my-5">
    <div class="d-flex justify-content-end mb-3">
      <button type="button" @click="downloadReport" class="btn btn-primary btn-sm">
        <i class="fas fa-file-pdf"></i> Download Report
      </button>
    </div>
    <c-data-list ref="dataList" :items="retainer.invoices">
        <template v-slot:columns>
          <div class="col-12 col-lg-3 col-xl-3">
            <p>Invoice No</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Type</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Due</p>
          </div>
          <div class="col-6 col-lg-1 col-xl-1">
            <p>Status</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Total</div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Balance</div>
        </template>
        <template v-slot:default="slotProps">
          <invoices-list-item :invoice="slotProps.item" :balance="slotProps.item.running_balance" />
        </template>
      </c-data-list>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import auth from "utils/auth";

import InvoicesListItem from "./InvoicesListItem"

export default {
  components: {
    InvoicesListItem
  },
  data: function () {
    return {
      loaded: false
    };
  },
  computed: {
    ...mapState("retainer", {
      retainer: "single",
    }),
  },

  methods: {
    ...mapActions("retainer", {
      getRetainer: "getSingle",
    }),
    downloadReport() {
      var link =
        process.env.VUE_APP_API_URL +
        '/retainers/' +
        this.retainer.id +
        '/report?token=' +
        auth.getToken();
      window.open(link);
    },
  },
};
</script>
